import { queryClient } from 'queries';

export const invalidateTaskQuery = async (taskId: number) => {
  await queryClient.invalidateQueries({
    predicate: (query) => {
      return (
        query.queryHash.includes('task-detail') &&
        query?.queryHash.includes(taskId.toString())
      );
    },
  });
};
